<template>
  <div class="level is-mobile">
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">{{ $t('general.board') }}</p>
        <p class="title is-size-1-widescreen is-size-3 is-size-2-desktop is-size-1-tablet">
          <b-tooltip :label="boardsLong.toString()" type="is-dark" aria-hidden="true">
            <span v-for="b in boards" :key="b">
              {{ b === 'LE' ? '-' : $t(`board-short-mapping.${b}`) }}
            </span>
          </b-tooltip>
          <span class="is-sr-only">{{ boardsLong.toString() }}</span>
        </p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">{{ $t('general.nights') }}</p>
        <p class="title is-size-1-widescreen is-size-3 is-size-2-desktop is-size-1-tablet">
          <MinMaxDispaly v-if="variants.length > 0" :min="nightsMin" :max="nightsMax" />
          <span v-if="variants.length <= 0">-</span>
        </p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">{{ $t('general.persons') }}</p>
        <p class="title is-size-1-widescreen is-size-3 is-size-2-desktop is-size-1-tablet">
          <MinMaxDispaly v-if="variants.length > 0" :min="personsMin" :max="personsMax" />
          <span v-if="variants.length <= 0">-</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MinMaxDispaly from '@/components/MinMaxDisplay'
export default {
  name: 'BoardNightsPersonsOverview',
  components: {
    MinMaxDispaly,
  },
  props: {
    variants: Array,
  },
  computed: {
    nightsMin() {
      if (!this.variants || this.variants.length == 0 || !this.variants.find(f => f.available > 0)) {
        return null
      }
      return this.variants.filter(f => f.available > 0).reduce((m, x) => (m < x.nights ? m : x.nights), this.variants.find(f => f.available > 0).nights)
    },
    nightsMax() {
      if (!this.variants || this.variants.length == 0 || !this.variants.find(f => f.available > 0)) {
        return null
      }
      return this.variants.filter(f => f.available > 0).reduce((m, x) => (m > x.nights ? m : x.nights), this.variants.find(f => f.available > 0).nights)
    },
    personsMin() {
      if (!this.variants || this.variants.length == 0 || !this.variants.find(f => f.available > 0)) {
        return null
      }
      return this.variants.filter(f => f.available > 0).reduce((m, x) => (m < x.persons ? m : x.persons), this.variants.find(f => f.available > 0).persons)
    },
    personsMax() {
      if (!this.variants || this.variants.length == 0 || !this.variants.find(f => f.available > 0)) {
        return null
      }
      return this.variants.filter(f => f.available > 0).reduce((m, x) => (m > x.persons ? m : x.persons), this.variants.find(f => f.available > 0).persons)
    },
    boards() {
      if (!this.variants || this.variants.length == 0) {
        return []
      }
      return [...new Set(this.variants.map(m => m.board.shortName))]
    },
    boardsLong() {
      if (!this.variants || this.variants.length == 0) {
        return []
      }
      return [...new Set(this.variants.map(m => m.board.longName))]
    },
  },
  mounted() {},
}
</script>
